// extracted by mini-css-extract-plugin
module.exports = {"logsListWrapper":"LogsList_logsListWrapper__Eifav"};